import { apiPost } from '@/lib/http/client';

/**
 * Store this org's Salesforce External Client App consumer key and secret.
 *
 * Salesforce restricted Connected App creation in Spring '26, so each customer
 * registers its own External Client App and supplies these. Nothing else can
 * connect until they are stored — the install endpoint refuses with a 400.
 *
 * The secret is never returned by any endpoint; it goes into the encrypted
 * `apps.secrets` store and only `credentials_configured` on the status response
 * reflects that it exists.
 */
export async function saveSalesforceCredentials(
  orgId: number | string,
  clientId: string,
  clientSecret: string
): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>(
    `/api/orgs/${orgId}/salesforce/credentials/`,
    { client_id: clientId, client_secret: clientSecret }
  );
}
